import React, { useRef } from 'react';
import { InputProps } from '../Input';
import { Masks, useMaskedInputProps } from 'react-native-mask-input';
import { TextInput } from 'react-native';
import InputBase, { innerTextInputStyles } from '../InputBase';
import { useIsDisabledByParent } from '../../IsDisabledProvider';
import { phoneNumberReg } from '../../../../utils/validators';

export type PhoneNumberOwnProps = {
    onChange: (text: string) => void;
    value: string | null;
};

export type PhoneNumberProps = PhoneNumberOwnProps &
    Omit<InputProps, 'onChange' | 'renderInputField' | 'onInputPress' | 'onLayout'>;

const PhoneNumber: React.FC<PhoneNumberProps> = ({ value, onChange, isDisabled, ...rest }) => {
    const isDisabledByParent = useIsDisabledByParent(isDisabled);
    const dateInputRef = useRef<React.LegacyRef<TextInput> | null>(null);
    /*
      to enable backwards compatibility, we need to use the mask if the value is empty.
      we don't want existing values to be masked and alter the value.
    */

    const [useMask, setUseMask] = React.useState(false);
    React.useEffect(() => {
        if (!value || phoneNumberReg.test(value)) {
            setUseMask(true);
        }
    }, [value]);

    const maskedProps = useMaskedInputProps({
        value: useMask ? value || undefined : '',
        mask: Masks.USA_PHONE,
        onChangeText: useMask ? onChange : () => {},
        maskAutoComplete: true,
    });

    return (
        <InputBase
            {...rest}
            isDisabled={isDisabledByParent}
            onInputPress={() => {
                (dateInputRef.current as any)?.focus?.();
            }}
            value={useMask ? maskedProps.value : value}
            maskPlaceholder={maskedProps.placeholder}
            renderInputField={({ onFocus, onBlur, hasFocus }) => (
                <TextInput
                    testID={rest.testID}
                    onFocus={onFocus}
                    onBlur={onBlur}
                    style={innerTextInputStyles}
                    {...(hasFocus && useMask ? maskedProps : {})}
                    onChange={(e) =>
                        useMask ? maskedProps.onChangeText(e.nativeEvent.text) : onChange(e.nativeEvent.text)
                    }
                    value={useMask ? maskedProps.value : value || ''}
                />
            )}
        />
    );
};

export default React.memo(PhoneNumber);
